import 'jquery-validation';
import 'inputmask';

export default class Validate {
    constructor() {
        jQuery.validator.addMethod("phoneRegex", function (value, element) {
            return /^((\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/g.test(value);
        });
    
        jQuery.validator.addMethod("emailRegex", function (value, element) {
            return /.+@.+\..+/i.test(value);
        });

        $('#landing-go-form').validate({
            onfocusout: false,
            rules: {
                'first-name': {
                    required: true,
                },
                'last-name': {
                    required: true,
                },
                email: {
                    required: true,
                    emailRegex: true,
                },
                phone: {
                    required: true,
                    phoneRegex: true,
                },
                policy: {
                    required: true,
                },
            },
            messages: {
                'first-name': {
                    required: 'Поле обязательно для заполнения',
                },
                'last-name': {
                    required: 'Поле обязательно для заполнения',
                },
                email: {
                    required: 'Поле обязательно для заполнения',
                    emailRegex: 'Введите корректную почту',
                },
                phone: {
                    required: 'Поле обязательно для заполнения',
                    phoneRegex: 'Введите корректный номер телефона',
                },
                policy: {
                    required: 'Поле обязательно для заполнения',
                },
            },
            errorPlacement : function( error, element ) {
                if (element.prop('type') === 'checkbox') {
                    error.insertAfter(element.parent());
                }
                else {
                    element.after(error);
                }
            }
        });

        let errors = {
            emptyText: 'Поле обязательно для заполнения',
            wrongText: 'Некорректный формат',
            largeSize: 'Файл не должен превышать 16мб',
            emptyFile: 'Файл пуст'
        };

        $('[data-validate-go-files]').change(function(){
            let filesExt = ['pdf', 'doc', 'docx'];
            let parts = $(this).val().split('.');
            let $el = $(this).prev('.file-upload-input__input');
            let errorBlock = $(this).next('.file-upload-input__errors');

            let size = 16 * 1024 * 1024;
            let form = document.getElementById('file-upload');
            let file = form.files[0];
            if (file) {
                if (filesExt.join().search(parts[parts.length - 1]) === -1) {
                    $el.addClass('error');
                    errorBlock.removeClass('hide');
                    errorBlock.text(errors.wrongText);
                } else if (file.size > size) {
                    $el.addClass('error');
                    errorBlock.removeClass('hide');
                    errorBlock.text(errors.largeSize);
                } else if (file.size == 0) {
                    $el.addClass('error');
                    errorBlock.removeClass('hide');
                    errorBlock.text(errors.emptyFile);
                } else {
                    $el.removeClass('error');
                    errorBlock.addClass('hide');
                    errorBlock.text('');
                }
            } else {
                $el.removeClass('error');
                errorBlock.addClass('hide');
                errorBlock.text('');
            }
        });

        function validateGoFileEmpty() {
            if($('[data-validate-go-files]').length !== 0) {
                let $el = $('[data-validate-go-files]');
                let fileBlock = $el.prev('.file-upload-input__input');
                let errorBlock = $el.next('.file-upload-input__errors');

                let form = document.getElementById('file-upload');
                let file = form.files[0];

                if (typeof file === 'undefined') {
                    fileBlock.addClass('error');
                    errorBlock.removeClass('hide');
                    errorBlock.text(errors.emptyText);
                }
            }
        }

        $("#landing-go-form").on('submit', (e) => {
            validateGoFileEmpty();
        });
    }
};
